import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { cn } from "@/cn";
import { DiscoveryProfileEditor } from "@/components/discovery/discovery-profile-editor";
import { PortalsProvidersPanel } from "@/components/portals/providers-panel";
import {
  useDiscoveryProfile,
  enabledCompanyCount,
  enabledProviderCount,
} from "@/hooks/useDiscovery";

type PageTab = "sources" | "providers";

export function PortalsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const initialTab: PageTab = tabParam === "providers" ? "providers" : "sources";
  const [tab, setTab] = useState<PageTab>(initialTab);
  const { data: profile } = useDiscoveryProfile();
  const enabledCount = enabledCompanyCount(profile);
  const providerCount = enabledProviderCount(profile);

  useEffect(() => {
    if (tabParam === "providers") {
      setTab("providers");
    } else if (tabParam === "sources" || !tabParam) {
      setTab("sources");
    }
  }, [tabParam]);

  function selectTab(next: PageTab) {
    setTab(next);
    setSearchParams(next === "sources" ? {} : { tab: next });
  }

  return (
    <>
      <header className="mb-8">
        <h1 className="text-2xl font-bold text-foreground">Discovery sources</h1>
        <p className="text-muted-foreground">
          Advanced defaults for Find Jobs. Everyday use: open Find Jobs → My sources, or Enable scan on an employer.
        </p>
      </header>

      <div className="mb-6 flex gap-1 border-b border-border">
        {(
          [
            { id: "sources" as const, label: `Sources (${enabledCount})` },
            {
              id: "providers" as const,
              label: `Providers (${providerCount})`,
            },
          ] as const
        ).map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => selectTab(t.id)}
            className={cn(
              "border-b-2 px-4 py-2 text-sm font-medium transition",
              tab === t.id
                ? "border-brand text-brand"
                : "border-transparent text-muted-foreground hover:text-foreground",
            )}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "sources" ? <DiscoveryProfileEditor /> : <PortalsProvidersPanel />}
    </>
  );
}
